/*
 * @Author: 周泽飞 zefei.zhou@tongdun.net
 * @Date: 2023-03-08 16:45:46
 * @LastEditors: 周泽飞 zefei.zhou@tongdun.net
 * @LastEditTime: 2023-03-08 18:56:20
 * @FilePath: /tntd/packages/tntd/src/drawer/drawer.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { DrawerProps as AntdDrawerProps } from 'antd/lib/drawer'
import LocaleReceiver from 'antd/lib/locale-provider/LocaleReceiver'
import classNames from 'classnames'
import React, { FC } from 'react'

import { ConfigConsumer } from 'antd/lib/config-provider'
import { default as AntdDrawer } from 'antd/lib/drawer'

export const Drawer: FC<AntdDrawerProps> = ({ closable, className, ...rest }) => (
  <ConfigConsumer>
    {({ getPrefixCls }) => {
      const prefixCls = getPrefixCls('drawer')
      return (
        <LocaleReceiver componentName="Drawer">
          {() => (
            <AntdDrawer
              className={classNames(prefixCls, 'tntd-drawer', className, {
                [`${prefixCls}-contain-closable`]: closable !== false,
              })}
              closable={closable}
              {...rest}
            />
          )}
        </LocaleReceiver>
      )
    }}
  </ConfigConsumer>
)
